import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const Reports: React.FC = () => {
  return (
    <PlaceholderPage
      title="Reports"
      description="View analytics and generate custom reports"
    />
  );
};

export default Reports;
